export enum STATUS_MAP {
  'APPLICATION RESPONSE NEEDED' = 'APPLICATION RESPONSE NEEDED',
  'ENROLLED' = 'ENROLLED',
  'FAILED ON ECS/DROPED TO PAPER' = 'SUBMITTED',
  'IN PROGRESS' = 'IN PROGRESS',
  'IN PROGRESS / PENDING' = 'IN PROGRESS / PENDING',
  'MEMBER ENROLLED' = 'MEMBER ENROLLED',
  'OTHERS' = 'OTHERS',
  'REJECTED' = 'REJECTED',
  'SUBMITTED TO HIGHMARK' = 'SUBMITTED TO HIGHMARK',
  'SUBMITTED' = 'SUBMITTED',
}

export enum APP_STATUS{
  IN_PROGRESS = "IN_PROGRESS",
  SUBMITTED = "SUBMITTED", // Submitted or Submitted-and-Approved
  SUBMITTED_TO_MN = "SUBMITTED TO MN",
  SUBMITTED_FOR_APPROVAL = "SUBMITTED FOR APPROVAL"
}